import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DevilsCrossRoadGameMode} from "../server/DevilsCrossRoadGameMode";
import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {gsap} from "gsap";
import {DevilsCrossRoadSound} from "../sound/DevilsCrossRoadSound";


export class EndBonusPresentation implements SimplePresentation {
    name: string;
    private mainTl: gsap.core.Timeline;

    shouldRun(): boolean {
        return (DevilsCrossRoad.model.data.mode === DevilsCrossRoadGameMode.FREESPIN || DevilsCrossRoad.model.data.mode === DevilsCrossRoadGameMode.SUPER_FREESPIN)
            && DevilsCrossRoad.model.data.nextMode === DevilsCrossRoadGameMode.NORMAL;
    }

    start(controller: SimplePresentationRunnerController): void {
        this.mainTl = gsap.timeline();

        controller.setSkipCallback(() => this.skip(controller));

        const myCoinPosArray: string [][] = DevilsCrossRoad.model.data.stickyCoins;
        const myClonedCoinPosArray: string [][] = Object.assign([], myCoinPosArray);
        const flattenedCoinPosResult = myClonedCoinPosArray.reduce((accumulator, value) => accumulator.concat(value), []);

        const myCoinValueArray: number [][] = DevilsCrossRoad.model.data.stickyCoinsValues;
        const myClonedCoinValueArray: number [][] = Object.assign([], myCoinValueArray);
        const flattenedCoinValueResult = myClonedCoinValueArray.reduce((accumulator, value) => accumulator.concat(value), []);

        this.mainTl.add(() => {
            DevilsCrossRoadSound.fadeMusic(0, 100);
            DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_LOOP_END});
            if (this.toPlayCountupSound(flattenedCoinValueResult)) {
                DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_MULTIPLIER_COUNTUP});
            }
        });
        this.mainTl.add(this.setupEndPresentation(flattenedCoinPosResult, flattenedCoinValueResult));

        this.mainTl.add(() => {
            controller.finish();
        });
    }

    public setupEndPresentation(flattenedCoinPositions: string [], flattenedCoinValues: number []): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        const idsToPlay: number [] = [];
        const coinValues: number [] = [];


        flattenedCoinPositions.forEach((symStr, index) => {
            if (symStr === "C" || symStr === "CX") {
                idsToPlay.push(index);
                coinValues.push(flattenedCoinValues[index]);
            }
        });

        tl.add(DevilsCrossRoad.freespinReelAreaView.playBonusEndCoinAnimation(idsToPlay, coinValues));
        tl.add(()=>{
            if( DevilsCrossRoad.model.gameData.accumulatedRoundWin > 0 && DevilsCrossRoad.model.totalWinRatioConfig!.bigWinLevel === -1){
                if (DevilsCrossRoadSound.soundPlayer.fetchSoundPlayer(DevilsCrossRoadSound.FS_MULTIPLIER_COUNTUP)?.isPlaying) {
                    DevilsCrossRoadSound.fadeAndStopSound({name:DevilsCrossRoadSound.FS_MULTIPLIER_COUNTUP,to:0,duration:100});
                }
            }
        },">");

        return tl;
    }

    private skip(controller: SimplePresentationRunnerController): void {
        this.mainTl.totalProgress(1);
        if (DevilsCrossRoadSound.soundPlayer.fetchSoundPlayer(DevilsCrossRoadSound.FS_COIN_MULTIPLIER)?.isPlaying) {
            DevilsCrossRoadSound.soundPlayer.stopTrack(DevilsCrossRoadSound.FS_COIN_MULTIPLIER);
        }

    }

    private toPlayCountupSound(coinValueArray: number[]): boolean {
        return coinValueArray.some((item:number) => item>0);
    }

}